export default "__VITE_ASSET__DWA8Va6z__"